export default __webpack_public_path__ + "static/s_02-dc5ffa314ae57b7797b2d48513554030.png";